import { PropsWithChildren } from 'react';

import { AuthenticatedTemplate } from '@azure/msal-react';
import { Box } from '@twilio-paste/core/box';
import { useUID } from '@twilio-paste/uid-library';

import { SideBar } from './SideBar';
import { TopBar } from './TopBar';

type LayoutProps = PropsWithChildren;

export function Layout({ children }: LayoutProps) {
  const topbarSkipLinkId = useUID();
  const mainContentSkipLinkId = useUID();

  return (
    <AuthenticatedTemplate>
      <TopBar id={topbarSkipLinkId}></TopBar>
      <SideBar topbarSkipLinkId={topbarSkipLinkId} mainContentSkipLinkId={mainContentSkipLinkId}>
        <Box margin="space40">{children}</Box>
      </SideBar>
    </AuthenticatedTemplate>
  );
}
